<script setup lang="ts">
import { useAttrs } from "vue";
import Card from "@/commons/components/atoms/Card/Card.vue";
import { Checkbox } from "@/commons/components/atoms/Checkbox";

const checked = defineModel<boolean>("modelValue", { default: false });
const attrs = useAttrs();
</script>

<template>
  <Card
    variant="outlined"
    v-bind="attrs"
    :class="['checkbox-card', { 'checkbox-card--checked': checked }]"
    @click.prevent="checked = !checked"
    :aria-checked="checked"
    tabindex="0"
    role="checkbox"
  >
    <div class="checkbox-card-content">
      <div>
        <slot />
      </div>
      <Checkbox
        :checked="checked"
        tabindex="-1"
        class="checkbox-card-checkbox"
      />
    </div>
  </Card>
</template>

<style lang="scss" scoped>
.checkbox-card {
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;

  &:hover,
  &:focus-visible {
    border-color: var(--clr-p5);
    background: var(--clr-p2);
  }

  &--checked {
    background: var(--clr-p1);

    &:hover,
    &:focus-visible {
      border-color: var(--clr-p7);
      background: var(--clr-p1);
      opacity: 0.9;
    }
  }
}

.checkbox-card-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.checkbox-card-checkbox {
  margin-left: 16px;
  pointer-events: none;
  background: var(--clr-p1);
}
</style>
